import { render, staticRenderFns } from "./two.vue?vue&type=template&id=473d78b1&scoped=true"
import script from "./two.vue?vue&type=script&lang=js"
export * from "./two.vue?vue&type=script&lang=js"
import style0 from "./two.vue?vue&type=style&index=0&id=473d78b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d78b1",
  null
  
)

export default component.exports